(ns common.patterns.feed-import
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/styles" :as mui-styles]
            ["src/svg/arrows/arrow-counter-clockwise-2.svg$default" :as Refresh]
            ["src/svg/inform/error-triangle-fill.svg$default" :as AlertIcon]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.adset :as adset-queries]
            [common.util :as util]
            [common.validators.core :as validators]
            [goog.object :as gobject]
            [manage.ad-variant.creation.content.hooks :as h]
            [manage.content-variant-page.queries :as content-queries]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defmodal re-import-confirmation :content-feed/re-import-confirmation
  [{:keys [re-import]}]
  ($ modal-v2
     {:title "Confirm content feed refresh"
      :icon ($ SvgIcon {:color "warning"}
               ($ AlertIcon))
      :footer ($ Stack {:direction "row" :gap 1}
                 ($ Button {:variant "text"
                            :sx #js {:color "text.primary"}
                            :onClick #(rf/dispatch [:modal/close])}
                    "Cancel")
                 ($ Button {:variant "contained"
                            :color "warning"
                            :onClick #(do (rf/dispatch [:modal/close])
                                          (re-import))}
                    "Refresh content feed"))}
     ($ Stack {:sx #js {:width "450px"}}
        ($ :p "Refreshing your content feed will discard all your inline content changes.
             This action is irreversible. Do you want to continue?"))))

(defn get-last-imported-label
  [import-data]
  (str "LAST IMPORTED: " (util/format-iso-string (:created-at import-data))))

(defui latest-import-chip
  [{:keys [is-import-running latest-import-data show-details-fn has-errors?]}]
  (cond
    is-import-running ($ Chip
                         {:label "IMPORT IS RUNNING"
                          :color "background.paper"
                          :sx #js {:fontWeight "600"}})
    latest-import-data ($ Tooltip
                          {:placement :bottom
                           :title (if has-errors? "Import has errors. Click to see details." "Click to see import details.")}
                          ($ Chip
                             (let [color (if has-errors? "warning" "")]
                               {:label (get-last-imported-label latest-import-data)
                                :variant "subtle"
                                :color color
                                :on-click show-details-fn
                                :sx (fn [^js theme]
                                      #js {:fontWeight "600"
                                           :backgroundColor (when-not has-errors?
                                                              "background.paper")
                                           "&:hover"
                                           (when has-errors?
                                             #js {:backgroundColor
                                                  (mui-styles/lighten
                                                   (gobject/get
                                                    (gobject/get (.. theme -palette) color)
                                                    "background")
                                                   0.2)})})})))
    :else nil))

(defui import-status-with-refresh
  [{:keys [children]}]
  (let [{:keys [advertiser-id adset-id] :as url-context} (use-subscribe [:url-context])
        {{feed-id :feedId workflow :workflow} :data} (use-query (adset-queries/adset-query {:adset-id adset-id}))

        {{latest-import-data :data} :data} (use-query (content-queries/latest-feed-import-status-query advertiser-id feed-id))
        is-import-running? (= "running" (:state latest-import-data))
        import-id (:id latest-import-data)
        import-has-errors? (pos? (:import-error-total latest-import-data))

        {trigger-feed-import :mutate} (use-mutation (content-queries/trigger-feed-import-mutation url-context feed-id))

        [import-disabled set-import-disabled] (uix/use-state false)

        can-safely-trigger-feed-import? (h/use-can-safely-trigger-feed-import? {:advertiser-id advertiser-id :feed-id feed-id})

        {{feed-errors-stats :data} :data} (use-query (content-queries/latest-feed-import-errors-query
                                                      advertiser-id feed-id import-id is-import-running?))

        show-details-fn #(rf/dispatch [:modal/open
                                       {:id :content-page/import-errors
                                        :props {:import-errors feed-errors-stats
                                                :feed-id feed-id
                                                :import-id import-id}}])

        is-internal-url (some-> (content-queries/get-feed advertiser-id feed-id)
                                use-query
                                (get-in [:data :url])
                                validators/internal-url?)]
    ($ Stack {:direction "row"
              :gap 1
              :alignItems "center"}
       children
       (when (and children (or latest-import-data is-import-running?))
         ($ Divider {:orientation "vertical" :flexItem true}))
       ($ latest-import-chip
          {:is-import-running is-import-running?
           :latest-import-data latest-import-data
           :has-errors? import-has-errors?
           :show-details-fn show-details-fn})
       (when-not is-internal-url
         ($ Button
            {:disabled (or import-disabled is-import-running?)
             :variant "contained"
             :color "grey"
             :onClick (fn []
                        (letfn [(re-import []
                                  (trigger-feed-import {:trigger-ad-variants? (= workflow "content-variants")})
                                  (set-import-disabled true)
                                  (js/setTimeout (fn []
                                                   (set-import-disabled false))
                                                 5000))]
                          (if can-safely-trigger-feed-import?
                            (re-import)
                            (rf/dispatch [:modal/open {:id :content-feed/re-import-confirmation
                                                       :props {:re-import re-import}}]))))
             :sx #js {:color "grey.10"}
             :startIcon ($ Refresh)}
            "Refresh feed")))))
